// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-playlist-js": () => import("../src/pages/playlist.js" /* webpackChunkName: "component---src-pages-playlist-js" */),
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

